import React from "react";
import trans from "../../../utils";
import PopupBodyItem from "../../Helpers/Popup/PopupParts/PopupBodyItem";
import { Image, Tag } from "antd";
import { formatDateString } from "../../../JsHelpers/DateFormat";

const ViewRequestBody = ({ data }) => {
  if (!data) return;

  const statusColors = {
    inProgress: `blue`,
    pending: `orange`,
    completed: `green`,
    cancelled: `red`,
    none: `default`,
    Assigned: `purple`,
  };

  return (
    <>
      <p className="fs-16 fw-500 brand-700 text-uppercase">
        {trans("Request Details")}
      </p>
      <div className="row">
        <div className="col-lg-12">
          <div className="display-border">
            <PopupBodyItem
              title={trans("Description")}
              item={data?.description}
            />
          </div>
        </div>
        <div className="col-lg-6">
          <div className="display-border">
            <PopupBodyItem
              title={trans("status")}
              item={
                <Tag
                  color={statusColors[data.status] || statusColors.none}
                  className="text-capitalize"
                >
                  {trans(data.status)}
                </Tag>
              }
            />
            <PopupBodyItem
              title={trans("User Name")}
              item={trans(data?.userName)}
            />
            <PopupBodyItem
              title={trans("preferred time")}
              item={
                data?.preferredTime && formatDateString(data?.preferredTime)
              }
            />
          </div>
        </div>
        <div className="col-lg-6">
          <div className="display-border">
            <PopupBodyItem
              title={trans("created at")}
              item={data?.createdAt && formatDateString(data?.createdAt)}
            />

            <PopupBodyItem title={trans("User")} item={trans(data?.userName)} />
            <PopupBodyItem
              title={trans("Email")}
              item={trans(data?.userEmail)}
            />
          </div>
        </div>
        {data?.photos?.length > 0 && (
          <div className="col-lg-12 mt-3">
            <p className="fw-500 mb-2">{trans("Photos")}</p>
            <Image.PreviewGroup>
              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(auto-fill, minmax(120px, 1fr))",
                  gap: "10px",
                }}
              >
                {data.photos.map((photo, index) => (
                  <Image
                    key={index}
                    src={photo?.url}
                    alt={`photo-${index}`}
                    style={{
                      width: "100%",
                      height: "100px",
                      objectFit: "cover",
                      borderRadius: "8px",
                    }}
                    fallback="https://via.placeholder.com/150?text=No+Image"
                    onError={(e) => {
                      e.target.onerror = null; // prevent loop
                      e.target.src =
                        "https://via.placeholder.com/150?text=Image+Not+Found";
                    }}
                  />
                ))}
              </div>
            </Image.PreviewGroup>
          </div>
        )}
      </div>
    </>
  );
};

export default ViewRequestBody;
